import { Trans } from "@lingui/react/macro"
import { Dialog, NavigationTrigger } from "@rarible_int/anaconda_ui_components"
import {
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from "@rarible_int/anaconda_ui_components"
import BaseLink from "next/link"
import { type ReactNode, useState } from "react"
import { useEvent } from "../hooks/use-event"
import { LINKS } from "./get-rari-links"

interface GetRariProps {
  triggerButton?: ReactNode
  openDialog?: boolean
  onOpenChange?: (open: boolean) => void
  dialogTriggerClassName?: string
}

export function GetRari({
  triggerButton,
  openDialog: externalOpenDialog,
  onOpenChange: externalOnOpenChange,
  dialogTriggerClassName,
}: GetRariProps) {
  const [internalOpenDialog, setInternalOpenDialog] = useState(false)

  const openDialog =
    externalOpenDialog !== undefined ? externalOpenDialog : internalOpenDialog
  const setOpenDialog = externalOnOpenChange || setInternalOpenDialog

  const onClick = useEvent(() => {
    setOpenDialog(!openDialog)
  })

  return (
    <Dialog open={openDialog} onOpenChange={setOpenDialog}>
      <DialogTrigger asChild id="get-rari-dialog">
        {triggerButton ? (
          <div onClick={onClick} className={dialogTriggerClassName}>
            {triggerButton}
          </div>
        ) : (
          <div className="flex items-center">
            <button
              type="button"
              className="whitespace-nowrap [text-shadow:0_0_8px_rgba(255,255,255,0.8)]"
              onClick={onClick}
            >
              <Trans>Get $RARI</Trans>
            </button>
          </div>
        )}
      </DialogTrigger>
      <DialogContent
        className="max-w-[394px]"
        aria-describedby="get-rari-dialog-trigger"
      >
        <DialogTitle className="block text-center font-medium text-lg">
          <Trans>Get $RARI</Trans>
        </DialogTitle>
        <div>
          <div className="flex flex-col items-center gap-y-2">
            {LINKS.map((link) => (
              <BaseLink
                href={link.href}
                className="w-full flex-grow"
                key={link.name}
                target="_blank"
                rel="noopener noreferrer"
              >
                <NavigationTrigger
                  active={true}
                  className="flex h-9 w-full justify-center rounded-md border border-foreground/[0.1] bg-foreground/[0.02] px-3 py-2 text-foreground/20 duration-200 hover:bg-foreground/[0.06]"
                >
                  <Trans>{link.name}</Trans>
                </NavigationTrigger>
              </BaseLink>
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
